import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AhsSplashService } from '../../core/services/ahs-splash.service';
import { AppCoreService } from '../../core/services/app-core.service';
//import { AhsSplashService } from './ahs-splash.service';

@Component({
	selector: 'ahs-splash',
	templateUrl: './ahs-splash.component.html',
	styleUrls: ['./ahs-splash.component.scss'],
	standalone: false
})
export class AhsSplashComponent implements OnInit {
	@Input() value: any;

	public appClientLogoImg: string;

	constructor(
		public splashService: AhsSplashService,
		private appCoreService: AppCoreService
	) {}

	ngOnInit() {}
}
